import React from 'react'
import { CustomerContact } from 'models/customer'
import './style.scss'

type Props = {
  contact: CustomerContact
}

export const CustomerContactDisplay = (props: Props) => {
  return (
    <div className="c-customer-contact-display">
      <div><span style={{ fontWeight: 400 }}>{props.contact.name}</span></div>
      <div>{props.contact.job_title}</div>
      <div> {props.contact.email}</div>
      <div> {props.contact.phone}</div>
    </div>
  )
}

export default CustomerContactDisplay